import { Dispatch } from 'react';
import { AuditLogActionTypes, EmpDetailsActionTypes } from './types';
import { EmpApi } from '../../api/EmpApi';
import { EmployeeData } from '../../shared/models/EmpDetails';
import { EmployeeScheduleRequest } from '../../shared/models';

export type AuditLogActions = FetchAuditLogsRequestAction | FetchAuditLogsFailureAction;

export type EmpDetailsAction = GetDataSuccess | DataLoadingAction;

export interface GetDataSuccess {
    type: EmpDetailsActionTypes.GET_DATA_SUCCESS;
    payload: {
        EmployeeNumber: string,
        EmailId: string,
        response: EmployeeData
    };
}


export interface FetchAuditLogsRequestAction {
    type: AuditLogActionTypes.FETCH_AUDIT_LOGS_REQUEST;
}



export interface FetchAuditLogsFailureAction {
    type: AuditLogActionTypes.FETCH_AUDIT_LOGS_FAILURE;
    error: string; // Or use a more specific error type
}

export const GetEmpDataSuccess = (empId: string, email: string, dataResponse?: EmployeeData) => {
    return (dispatch: Dispatch<EmpDetailsAction>) => {
        dispatch({
            payload: {
                EmployeeNumber: empId,
                EmailId: email,
                response: dataResponse,
            },
            type: EmpDetailsActionTypes.GET_DATA_SUCCESS,
        });
    };
};


export interface DataLoadingAction {
    type: EmpDetailsActionTypes.DATA_LOADING;
}

export const getEmpDetails = (employeeId: string, email: string) => {
    return (dispatch: Dispatch<any>) => {
        return EmpApi.auth().GetEmpDetails(employeeId, email)
            .then((response: any) => {
                dispatch(GetEmpDataSuccess(employeeId, email, response));
                if (response) {
                    return response;
                } else {
                    return undefined;
                }
            }, (_error: any) => {
                return undefined;
            });
    };
}

export const updateEmployeeSchedule = (employeeScheduleRequest: EmployeeScheduleRequest) => {
    return (dispatch: Dispatch<any>) => {
        return EmpApi.auth().updateEmployeeSchedule(employeeScheduleRequest)
            .then((response: any) => {
                if (response) {
                    return response;
                } else {
                    return undefined;
                }
            }, (_error: any) => {
                return undefined;
            });
    };
}


